import { render, staticRenderFns } from "./pedidos.vue?vue&type=template&id=560a9c7c"
import script from "./pedidos.vue?vue&type=script&lang=js"
export * from "./pedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports